module.exports = __webpack_public_path__ + "media/images/photo/high_speed_internet_text-d9a7a442fe8f5432730ebdd3fdc723d5.png";